export default "__VITE_ASSET__MmAp6LaF__"